import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../ui/Logo';
import { LinkedinIcon, YoutubeIcon, TwitterIcon } from 'lucide-react';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-white border-t border-gray-200 pt-12 pb-8" data-id="element-33">
      <div className="container-custom" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-35">
          <div className="col-span-1" data-id="element-36">
            <Logo className="mb-4" data-id="element-37" />
            <p className="text-sm text-gray-600 mb-4" data-id="element-38">
              Simplifying daily workflows, client communication, and team
              collaboration in one place.
            </p>
            <div className="flex space-x-4" data-id="element-39">
              <a href="https://linkedin.com" className="text-gray-400 hover:text-brand-blue transition-colors duration-200" data-id="element-40">
                <LinkedinIcon size={20} data-id="element-41" />
              </a>
              <a href="https://twitter.com" className="text-gray-400 hover:text-brand-blue transition-colors duration-200" data-id="element-42">
                <TwitterIcon size={20} data-id="element-43" />
              </a>
              <a href="https://youtube.com" className="text-gray-400 hover:text-brand-blue transition-colors duration-200" data-id="element-44">
                <YoutubeIcon size={20} data-id="element-45" />
              </a>
            </div>
          </div>
          <div className="col-span-1" data-id="element-46">
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-47">
              Product
            </h3>
            <ul className="space-y-2" data-id="element-48">
              <li data-id="element-49">
                <Link to="/platform" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-50">
                  Platform
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/solutions" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-52">
                  Solutions
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/pricing" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-54">
                  Pricing
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/faqs" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-56">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-span-1" data-id="element-57">
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-58">
              Company
            </h3>
            <ul className="space-y-2" data-id="element-59">
              <li data-id="element-60">
                <Link to="/about" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-61">
                  About
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/contact" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-63">
                  Contact
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/careers" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-65">
                  Careers
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-span-1" data-id="element-66">
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-67">
              Legal
            </h3>
            <ul className="space-y-2" data-id="element-68">
              <li data-id="element-69">
                <Link to="/privacy" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-70">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/terms" className="text-gray-600 hover:text-brand-teal text-sm transition-colors duration-200" data-id="element-72">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
            <div className="mt-4" data-id="element-73">
              <p className="text-sm text-gray-600" data-id="element-74">
                <a href="mailto:rapeezshrestha385@gmail.com" className="hover:text-brand-teal transition-colors duration-200" data-id="element-75">
                  rapeezshrestha385@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-76">
          <p className="text-sm text-center text-gray-500" data-id="element-77">
            &copy; {currentYear} Daily Serve. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};